import Router from 'vue-router';
import { QueryString } from './QueryString';

export class FilterHelper {
	constructor (private readonly router: Router) { }

	public setKeywords (keywords: string): void {
		const search = this.queryString.get('search') || 'programs';

		this.queryString.clearAllExcept('term').set('search', search).set('keywords', keywords).navigate();
	}

	public clearKeywords (): void {
		this.queryString.clear('keywords').clear('page').navigate();
	}

	public setFilter (name: string, value: string): void {
		this.queryString.set(name, value).clear('page').navigate();
	}

	public clearFilter (name: string): void{
		this.queryString.clear(name).clear('page').navigate();
	}

	public setPage (page: number): void {
		this.queryString.set('page', page).navigate();
	}

	public setPageSize (size: number): void {
		this.queryString.set('pageSize', size).clear('page').navigate();
	}

	public setSort (key: string): void {
		this.queryString.set('sort', key).clear('page').navigate();
	}

	public setSearch (search: string): void {
		this.queryString.set('search', search).clear('page').navigate();
	}

	private get queryString (): QueryString {
		return new QueryString(this.router);
	}
}
